<template>
    <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
            <b-col md="6">
            <b-card-img :src="personDeparture.person_entry.person.photo" class="rounded-0"></b-card-img>
            </b-col>
            <b-col md="6">
            <b-card-body :title="`Salida ${personDeparture.person_entry.person.name}`">
                <!-- <b-card-text> -->
                    <b-container>
                        <b-row>
                            <b-col cols="12" md="5">Nombre</b-col>
                            <b-col>{{ personDeparture.person_entry.person.name }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="5">Documento</b-col>
                            <b-col>{{ personDeparture.person_entry.person.document }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="5">Fecha de Salida</b-col>
                            <b-col>{{ personDeparture.created_at | datetime }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="5">Estructura</b-col>
                            <b-col>{{ !!personDeparture.person_entry.person.structure? personDeparture.person_entry.person.structure.name: 'Visitante' }}</b-col>
                        </b-row>
                    </b-container>
                <!-- </b-card-text> -->
            </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
    name: 'person_departure_card',
    props: {
        personDeparture: {
            type: Object,
            required: true
        }
    }
}
</script>